// TODO: Move that to pull-raceresult service.
export function parseTagObjectLegacy(tags: string): Record<string, string> {
  if (tags != null) {
    const tagPairs = tags.split(',').map((item) => item.split(':').map((s) => s.trim()));
    const validPairs = tagPairs.filter((p) => typeof p[1] === 'string' && p[1] !== '');
    return Object.fromEntries(validPairs);
  }
  return {};
}

export function parseNestedObject(
  record: Array<string>,
  mapping: Record<string, number>,
): Record<string, string> {
  // parse prefix based csv collumns, so for example you want to store { times: { start: '2022-09-12T13:49:09.669Z', end: '2022-09-12T13:49:09.669Z' }}
  // you add for every entry a column with the record name as prefix and the key as suffix, splitted by a dot or underscore
  // ...,times_start,times_end,...
  // ...,2022-09-12T13:49:09.669Z,2022-09-12T13:49:09.669Z,...
  const output: Record<string, string> = {};

  for (const [header, columnIndex] of Object.entries(mapping)) {
    const splitter = getSplitter(header);
    // receive the second part of the header without the top-topic, for example times_start -> start
    const headerPure = header.split(splitter)[1];
    if (headerPure == null)
      throw new Error(`CSV Parsing Error: Receive a wrong prefixed subcolumn. Header: ${header}`);

    const value = record[columnIndex];
    if (value == null || value.trim() === '') continue;
    output[headerPure] = value;
  }

  return output;
}

const getSplitter = (header: string): '.' | '_' => {
  if (header.includes('.')) return '.';
  if (header.includes('_')) return '_';
  throw new Error(
    `CSV Parsing Error: Receive a wrong prefixed subcolumn. Use '.' or '_'. Header: ${header}`,
  );
};

// TODO: Legacy -> Remove
export function formatTagObject(tags: Record<string, string>): string {
  if (tags != null) {
    return Object.entries(tags)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
  }
  return '';
}

export function formatNestedObject(
  object: Record<string, string | undefined>,
  possibleKeys: Array<string>,
): Array<string> {
  return possibleKeys.map((k) => object[k] || '');
}

// convert one byte hex to binary
export function hex2bin(hex: string): string {
  return Number.parseInt(hex, 16).toString(2).padStart(8, '0');
}

export function formatLabel(parts: Array<string | undefined | null>): string {
  const label = parts.filter((item) => item != null && item !== '').join(' ');
  return label || 'N/A';
}
